import { QuestionIndexing } from "@kunduz/data-access-qi-api";
import React, { ReactElement, useState } from "react";
import { AnswerImageModal } from "./answerImageModal";
import { prepareImageUrl } from "./common";
import styles from "./unlockedAnswerImage.module.scss";

export function UnlockedAnswerImage(props: Props): ReactElement {
  const [showModal, setShowModal] = useState(false);
  const { question } = props;

  function onModalClose() {
    setShowModal(false);
  }

  return (
    <>
      <div className={styles["answerImageWrapper"]}>
        <img
          src={prepareImageUrl(question.raw_answer_image, 512)}
          className="answer-image"
          alt={
            question.structured_data?.acceptedAnswer?.text || question.seo_meta
          }
          loading="lazy"
          onClick={() => setShowModal(true)}
        />
      </div>
      <AnswerImageModal
        question={props.question}
        visible={showModal}
        onClose={onModalClose}
      />
    </>
  );
}

interface Props {
  question: QuestionIndexing.TrQiQuestion;
}
